'use client'
import { useMessages, useTranslations } from 'next-intl'
import { useEffect, useRef, useState } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { motion } from 'framer-motion'
import { useRouter } from 'navigation'
const TermsTabs = ({ location, service }) => {
  const t = useTranslations('terms')
  const messages = useMessages()
  const tabs = Object.keys(messages['terms'].tabs)
  const contentRef = useRef()
  const router = useRouter()
  const [horizontalScrollPercentage, setHorizontalScrollPercentage] =
    useState(0)
  const handelChangeActiveTab = (key) => {
    router.push(
      `/${t(`tabs.${key}.path`, { location: location })}`,
      undefined,
      { shallow: false }
    )
  }
  useEffect(() => {
    setHorizontalScrollPercentage(0)
  }, [])
  const handleScrollTabsContainer = (n) => {
    const tabsContainer = document.querySelector('#fleet-tabs-container')

    const scrollPercentage =
      (tabsContainer.scrollLeft /
        (tabsContainer.scrollWidth - tabsContainer.clientWidth)) *
      100

    setHorizontalScrollPercentage(Math.ceil(scrollPercentage))
    tabsContainer.scrollBy({
      left: n,
      behavior: 'smooth',
    })
  }
  return (
    <div className={`flex items-center mb-[36px] px-[15px]`}>
      <div
        className='cursor-pointer block lg:hidden'
        onClick={() => handleScrollTabsContainer(-60)}
      >
        <ChevronLeft
          color={horizontalScrollPercentage === 0 ? '#9e9e9e' : 'black'}
        />
      </div>
      <div
        ref={contentRef}
        id='fleet-tabs-container'
        className='hide-scroll-bar  overflow-y-hidden  flex gap-5 max-w-full w-full overflow-x-scroll  h-[28px]'
      >
        {tabs.map((key) => (
          <button
            type='button'
            key={key}
            onClick={() => handelChangeActiveTab(key)}
            className={`whitespace-nowrap relative font-light outline-sky-400 transition ${
              service === t(`tabs.${key}.key`).toLowerCase()
                ? ' font-normal'
                : ''
            }`}
          >
            {decodeURIComponent(service) === t(`tabs.${key}.key`) && (
              <motion.span
                layoutId='underline'
                className={`absolute inline-block left-0 w-full h-[2px] bottom-0 z-0 first-letter bg-black `}
                transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
              />
            )}
            {t(`tabs.${key}.title`).toUpperCase()}
          </button>
        ))}
      </div>
      <div
        className='cursor-pointer block lg:hidden'
        onClick={() => handleScrollTabsContainer(60)}
      >
        <ChevronRight
          color={horizontalScrollPercentage >= 99 ? '#9e9e9e' : 'black'}
        />
      </div>
    </div>
  )
}

export default TermsTabs
